import {
  useState,
  useEffect
} from "react";

const Timer = ({ isPaused }) => {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(true);

  useEffect(() => {
    let interval;

    if (!isPaused) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 1000);
      }, 1000);
    } else if (isPaused) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isPaused]);

  let h = ('0' + Math.floor((time / 3600000) % 60)).slice(-2);
  let m = ('0' + Math.floor((time / 60000) % 60)).slice(-2);
  let s = ('0' + Math.floor((time / 1000) % 60)).slice(-2);

  return `${h} : ${m} : ${s}`;
}

export default Timer;